import {
  Button,
  ButtonProps,
  FormControl,
  FormErrorMessage,
  FormLabel,
  Input,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalOverlay,
  useDisclosure,
  VStack,
} from "@chakra-ui/react";
import { useFormik } from "formik";
import { useState } from "react";
import * as yup from "yup";
import useCustomToast from "../../lib/useCustomToast";
import { axiosSupplier } from "../../utils/AxiosInstance";
import { ModalTitle } from "../card/ModalTitle";

interface Props extends ButtonProps {
  id: any;
  onRefresh?: (type: number) => void;
}

export const AddResiModal = ({ id, onRefresh, ...rest }: Props) => {
  const [loading, setLoading] = useState<boolean>(false);
  const toast = useCustomToast();
  const { isOpen, onOpen, onClose } = useDisclosure();

  const formik = useFormik({
    initialValues: { resi: undefined },
    validationSchema: yup.object().shape({
      resi: yup.string().required("Nomor Resi harus diisi"),
    }),
    onSubmit: (values) => {
      setLoading(true);

      axiosSupplier
        .put(`/v1/supplier/update-resi/${id}`, { resi: values.resi })
        .then((res) => {
          onClose();
          if (onRefresh) {
            onRefresh(1);
          }

          toast({
            title: res.data.message ?? "Berhasil menambahkan resi",
            status: "success",
          });
        })
        .catch((err) => {
          toast({
            description: err?.response?.data?.message || "",
          });
        })
        .finally(() => {
          setLoading(false);
        });
    },
  });

  return (
    <>
      <Button
        size={["sm", null, null, "md"]}
        variant={"outline"}
        colorScheme="red"
        flex={[1, 1, 1, "none", "none"]}
        onClick={onOpen}
        {...rest}
      >
        Tambahkan Resi
      </Button>

      <Modal isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent>
          <form id="addResiForm" onSubmit={formik.handleSubmit}>
            <ModalCloseButton />
            <ModalBody>
              <VStack w={"100%"} align={"stretch"}>
                <ModalTitle
                  title="Tambahkan Resi"
                  subtitle="Masukkan nomor resi dari paket yang anda kirimkan"
                />

                <FormControl
                  isInvalid={
                    formik.errors.resi && formik.touched.resi ? true : false
                  }
                >
                  <FormLabel htmlFor="resi">Nomor Resi</FormLabel>
                  <Input
                    name="resi"
                    type="text"
                    autoComplete="off"
                    onChange={formik.handleChange}
                    value={formik.values.resi || ""}
                  />

                  <FormErrorMessage>{formik.errors.resi}</FormErrorMessage>
                </FormControl>
              </VStack>
            </ModalBody>

            <ModalFooter>
              <Button
                variant={"ghost"}
                size={["xs", null, "sm"]}
                onClick={onClose}
              >
                Batal
              </Button>

              <Button
                variant={"solid"}
                colorScheme="red"
                size={["xs", null, "sm"]}
                form="addResiForm"
                isLoading={loading}
                loadingText="Loading"
                spinnerPlacement="start"
                type="submit"
              >
                Tambahkan
              </Button>
            </ModalFooter>
          </form>
        </ModalContent>
      </Modal>
    </>
  );
};
